/**
 * Notification type constants
 * Centralized definition of all notification types used across the application
 */

export const NOTIFICATION_TYPES = {
    // Social interactions
    LIKE: 'like',
    COMMENT: 'comment',
    REPLY: 'reply',
    SHARE: 'share',
    MENTION: 'mention',

    // Follow actions
    FOLLOW: 'follow',
    FOLLOW_BACK: 'follow_back',
    FOLLOW_REQUEST: 'follow_request',
    FOLLOW_REQUEST_ACCEPTED: 'follow_request_accepted',

    // Messaging
    MESSAGE: 'message',

    // Solutions
    SOLUTION_VOTE: 'solution_vote',
    SOLUTION_REASON: 'solution_reason',

    // Projects
    PROJECT_INVITE: 'project_invite',
    PROJECT_INVITE_ACCEPTED: 'project_invite_accepted',
    PROJECT_LAUNCHED: 'project_launched',
    TASK_ASSIGNMENT: 'task_assignment',
    TASK_COMMENT: 'task_comment',
};

/**
 * Notification categories for filtering
 */
export const NOTIFICATION_CATEGORIES = {
    SOCIAL: [
        NOTIFICATION_TYPES.LIKE,
        NOTIFICATION_TYPES.COMMENT,
        NOTIFICATION_TYPES.REPLY,
        NOTIFICATION_TYPES.SHARE,
        NOTIFICATION_TYPES.MENTION,
        NOTIFICATION_TYPES.FOLLOW,
        NOTIFICATION_TYPES.FOLLOW_BACK,
        NOTIFICATION_TYPES.FOLLOW_REQUEST,
        NOTIFICATION_TYPES.FOLLOW_REQUEST_ACCEPTED,
        NOTIFICATION_TYPES.MESSAGE,
    ],
    PROJECT: [
        NOTIFICATION_TYPES.PROJECT_INVITE,
        NOTIFICATION_TYPES.PROJECT_INVITE_ACCEPTED,
        NOTIFICATION_TYPES.PROJECT_LAUNCHED,
        NOTIFICATION_TYPES.TASK_ASSIGNMENT,
        NOTIFICATION_TYPES.TASK_COMMENT,
    ],
    SOLUTION: [
        NOTIFICATION_TYPES.SOLUTION_VOTE,
        NOTIFICATION_TYPES.SOLUTION_REASON,
    ],
};

/**
 * Types that can be aggregated (e.g., "John and 3 others liked your post")
 */
export const AGGREGATABLE_TYPES = [
    NOTIFICATION_TYPES.LIKE,
    NOTIFICATION_TYPES.COMMENT,
    NOTIFICATION_TYPES.FOLLOW,
];

/**
 * High priority notification types that should not be aggregated
 */
export const HIGH_PRIORITY_TYPES = [
    NOTIFICATION_TYPES.PROJECT_INVITE,
    NOTIFICATION_TYPES.MESSAGE,
    NOTIFICATION_TYPES.MENTION,
    NOTIFICATION_TYPES.FOLLOW_REQUEST,
];

/**
 * All valid notification types as an array (for validation)
 */
export const ALL_NOTIFICATION_TYPES = Object.values(NOTIFICATION_TYPES);
